import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { adaptLanguage, getCurrentLanguage, Language, LanguageKey } from '../language';
import { isBuildIn, commonInjector } from '../build-in';

// 语言切换使用的 cookie key

// locale 文件
import zhHans from './locales/zh-hans';
import zhHant from './locales/zh-hant';
import en from './locales/en';
import de from './locales/de';
import es from './locales/es';
import ja from './locales/ja';
import ru from './locales/ru';

/**
 * 翻译资源
 */
export const translationResources = {
  [Language.zhHans]: {
    translation: zhHans,
    ...zhHans,
  },
  [Language.zhHans.toLowerCase()]: {
    translation: zhHans,
    ...zhHans,
  },
  [Language.zhHant]: {
    translation: zhHant,
    ...zhHant,
  },
  [Language.zhHant.toLowerCase()]: {
    translation: zhHant,
    ...zhHant,
  },
  [Language.en]: {
    translation: en,
    ...en,
  },
  [Language.de]: {
    translation: de,
    ...de,
  },
  [Language.es]: {
    translation: es,
    ...es,
  },
  [Language.ja]: {
    translation: ja,
    ...ja,
  },
  [Language.ru]: {
    translation: ru,
    ...ru,
  },
};

/**
 * 创建独立的 i18n 实例，用于应用级别的国际化
 * 与 chat-ai 的 i18n 实例分离，避免冲突
 */
const appI18n = i18next.createInstance();

void appI18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: getCurrentLanguage(),
    fallbackLng: [Language.zhHans, Language.en],
    supportedLngs: [
      Language.zhHans,
      Language.zhHans.toLowerCase(),
      Language.zhHant,
      Language.zhHant.toLowerCase(),
      Language.en,
      Language.de,
      Language.es,
      Language.ja,
      Language.ru,
    ],
    load: 'currentOnly',
    resources: translationResources,
    returnNull: false,
    initImmediate: false,
    interpolation: {
      escapeValue: false, // React 已经处理了 XSS
      defaultVariables: {
        currency: isBuildIn() ? 'USD' : '元',
        currencySymbol: isBuildIn() ? '$' : '¥',
        productName: commonInjector.productName,
        productAiName: commonInjector.productAiName,
        productAllName: commonInjector.productAllName,
      },
    },
    detection: {
      order: ['cookie'],
      caches: ['cookie'],
      cookieOptions: {
        maxAge: 31536000000,
      },
      lookupCookie: LanguageKey,
      convertDetectedLanguage: (lng: string) => adaptLanguage(lng),
    },
  });

export default appI18n;
export { appI18n };
export const i18n = appI18n;
export { useAppTranslation, changeAppLanguage } from './use-translation';
export { toDayjsDateFormat } from './date-format';
